































import gql from 'graphql-tag'
import { Component, Mixins } from 'vue-property-decorator'

import AppTitleBar from '@/components/AppTitleBar.vue'
import { Common } from '@/mixins'

@Component({
  components: {
    AppTitleBar
  },
  apollo: {
    orderItemPaybacksByHistoryId: {
      query: gql`query orderItemPaybacksByHistoryIdAtCreatorRewardsPayback($historyId: ID!) {
        orderItemPaybacksByHistoryId(historyId: $historyId) {
         id
         amount
         couponApplied
         orderItem {
           id
           itemVariantOption
           item {
             id
             name
             medias {
               id
               path
             }
           }
         }
        }
      }`,
      variables () { return { historyId: this.$route.params.historyId } }
    }
  }
})
export default class extends Mixins(Common) {
  orderItemPaybacksByHistoryId = []
}
